/* istanbul ignore file */
import { Route, Routes } from 'react-router-dom';
import { TeamLayout } from '@/components/layout/team/TeamLayout';
import { ProtectedVideoRoute } from '@/components/routes/ProtectedVideoRoute';
import { PitchSelectVideoPreview as TeamPitchVisVideoPreview } from '@/components/video/PitchSelectVideoPreview';
import { PlayerVideoPreview } from '@/components/video/PlayerVideoPreview';
import { PlayerDataLockerPlayerPreview } from '@/pages/dataLocker/aggregates/player/PlayerDataLockerPlayerPreview';
import { PlayerDataLockerPreview } from '@/pages/dataLocker/aggregates/player/PlayerDataLockerPreview';
import { NotFound } from '@/pages/NotFound';
import { TeamDashboardPage } from '@/pages/team/dashboard/TeamDashboardPage';
import { TeamGamesPage } from '@/pages/team/games/TeamGamesPage';
import { GameGoalsVideoPage } from '@/pages/team/games/video/GameGoalsVideoPage';
import { TeamGamesVideoPreview } from '@/pages/team/games/video/TeamGamesVideoPreview';
import { TeamPreview } from '@/pages/team/preview/TeamPreview';
import { TeamRadarPage } from '@/pages/team/radar/TeamRadarPage';
import { TeamSquadPage } from '@/pages/team/squad/TeamSquadPage';
import { TeamVisPage } from '@/pages/team/vis/TeamVisPage';

export const TeamRoutes = () => (
  <Routes>
    <Route element={<TeamLayout />}>
      <Route path="dashboard" element={<TeamDashboardPage />} />
      <Route path="radar" element={<TeamRadarPage />}>
        <Route path="preview" element={<TeamPreview />} />
      </Route>
      <Route path="vis" element={<TeamVisPage />}>
        <Route path="preview" element={<ProtectedVideoRoute component={<TeamPitchVisVideoPreview />} />} />
      </Route>
      <Route path="squad" element={<TeamSquadPage />}>
        <Route path="preview" element={<PlayerDataLockerPreview />} />
        <Route path="player/preview" element={<PlayerDataLockerPlayerPreview />} />
        <Route path="video/preview" element={<ProtectedVideoRoute component={<PlayerVideoPreview />} />} />
      </Route>
      <Route path="matches" element={<TeamGamesPage />}>
        <Route path="video/preview" element={<ProtectedVideoRoute component={<TeamGamesVideoPreview />} />} />
      </Route>
      <Route path="matches/video/goals" element={<ProtectedVideoRoute component={<GameGoalsVideoPage />} />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);
